(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ak-inpiration"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('.ak-inspiration');
    if (!section) return;

    const filters = section.querySelectorAll('.ak-filter');
    const items = section.querySelectorAll('.ak-inspiration__item');
    const empty = section.querySelector('#ak-inspiration-empty');

    filters.forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.color;

        filters.forEach((f) => {
          f.classList.remove('ak-filter--active');
          f.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('ak-filter--active');
        btn.setAttribute('aria-selected', 'true');

        let visibleCount = 0;
        items.forEach((item) => {
          const itemColor = item.dataset.color;
          const shouldShow = target === 'all' || itemColor === target;
          item.classList.toggle('is-hidden', !shouldShow);
          if (shouldShow) visibleCount++;
        });

        if (empty) {
          empty.hidden = visibleCount > 0;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
